import { render } from "./index.vue?vue&type=template&id=6da3700a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6da3700a&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da3700a"]])

export default __exports__